/**
 * @module FieldControls
 */
import { FormHelperText, InputAdornment, TextField, Typography } from '@material-ui/core';
import { deepMerge, toNumber } from '@sensenet/client-utils';
import React, { useState } from 'react';
import { changeTemplatedValue, formatSize } from "../helpers.js";
import { defaultLocalization } from "./localization.js";
/**
 * Field control that represents a Number field. Available values will be populated from the FieldSettings.
 */
export const FileSizeField = props => {
  var _props$localization;
  const localization = deepMerge(defaultLocalization.fileSize, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.fileSize);
  const initialState = props.fieldValue != null ? props.fieldValue : props.actionName === 'new' && props.settings.DefaultValue !== undefined && Number.parseInt(changeTemplatedValue(props.settings.DefaultValue), 10) || undefined;
  const [value, setValue] = useState(initialState);
  const handleChange = e => {
    var _props$fieldOnChange;
    setValue(e.target.value);
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, e.target.value);
  };

  /**
   * Returns steps value by decimal and step settings
   */
  const defineStepValue = () => {
    if (props.settings.Step) {
      return props.settings.Step;
    }
    if (!props.fieldValue) {
      return 1;
    }
    return Number.isInteger(toNumber(props.fieldValue)) || props.settings.Type === 'IntegerFieldSetting' ? 1 : 0.1;
  };
  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
        autoFocus: props.autoFocus,
        name: props.settings.Name,
        type: "number",
        label: props.settings.DisplayName,
        value: value,
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly,
        placeholder: props.settings.DisplayName,
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "end"
          }, "byte")
        },
        inputProps: {
          step: defineStepValue(),
          max: props.settings.MaxValue,
          min: props.settings.MinValue
        },
        id: props.settings.Name,
        fullWidth: true,
        onChange: handleChange
      }), !props.hideDescription && /*#__PURE__*/React.createElement(FormHelperText, null, props.settings.Description));
    case 'browse':
    default:
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        gutterBottom: true
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        gutterBottom: true
      }, props.fieldValue && props.fieldValue !== '0' ? /*#__PURE__*/React.createElement(React.Fragment, null, formatSize(toNumber(props.fieldValue), 0)) : localization.noValue));
  }
};
//# sourceMappingURL=file-size.js.map